import * as React from 'react';
import { formatoDecimal } from '../../../../utilities/formatoNumeros';

export default class LiquidacionNewNovedades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            novedades: props.novedades,
            seleccionarTodo: false
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.novedades !== this.props.novedades) {
            this.setState({ novedades: this.props.novedades })
        }
    }

    handleChangeCheckbox = (id) => {
        this.setState((prevState) => {
            const novedades = prevState.novedades.map((novedad) => {
                if (novedad.idNovedad === id) {
                return {
                    ...novedad,
                    checked: !novedad.checked
                };
                }
                return novedad;
            });
            return { novedades };
        });
    };

    handleSelectAllCheckbox(seleccionarTodo) {
        this.setState((prevState) => {
            const novedades = prevState.novedades.map((novedad) => ({
                ...novedad,
                checked: seleccionarTodo
            }));
            return { novedades };
        });

        this.setState({ seleccionarTodo: seleccionarTodo });
    };


    render = () => {

        return (

            this.state.novedades.length === 0 ?

            <h5 className="d-flex justify-content-center m-t-40 m-b-40">
                NO SE ENCONTRARON NOVEDADES PARA ESTE SELLER
            </h5>

            :

            <div className="row justify-content-between align-items-center p-10">

                <div className="col-auto my-4">
                    <input
                        type="checkbox" 
                        className="big-checkbox"
                        checked={this.state.seleccionarTodo}
                        onChange={() => this.handleSelectAllCheckbox(!this.state.seleccionarTodo)}
                    />
                    <h6 className="d-inline-flex mx-2">Seleccionar todo</h6>
                </div>

                <h4 className="col-auto card-title">Novedades aptas para liquidar</h4>

                <div className="list-group-item col-12 animated fadeIn">
                    <div className="table-responsive card">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col-1"><small>#</small></th>
                                    <th scope="col-3"><small>Fecha</small></th>
                                    <th scope="col-2"><small>Acción</small></th>
                                    <th scope="col-3"><small>Tipo</small></th>
                                    <th scope="col-1"><small>Importe</small></th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.novedades.map((novedad, i) => {
                                    return (
                                        <tr key={i} className="hover-background-color">
                                            <td>
                                                <input 
                                                    type="checkbox" 
                                                    className="big-checkbox ml-2"
                                                    checked={novedad.checked || false}
                                                    onChange={() => this.handleChangeCheckbox(novedad.idNovedad)}
                                                />
                                            </td>
                                            <td><small>{novedad.fechaNovedad}</small></td>
                                            <td><small>{novedad.descripcionSubTipoNovedad}</small></td>
                                            <td><small>{novedad.detalleTipoNovedad}</small></td>
                                            <td><small>${formatoDecimal(novedad.importe)}</small></td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>
        );
    }
}